import React from "react";
import { useTranslation } from 'react-i18next';

interface AsianAlleyInvestSectionProps {
  onConsultClick: () => void;
}

const AsianAlleyInvestSection = ({
  onConsultClick,
}: AsianAlleyInvestSectionProps) => {
  const { t } = useTranslation('latvia');

  return (
    <article className="py-8 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-12 items-center">
          <div className="relative">
            <img
              src="https://static.readdy.ai/image/bb12603af26d1f2ac82c77bdc32217c8/01e85f8cbfd3d919f89bf6540caea035.jpeg"
              alt="Đầu tư định cư Latvia - Siêu thị Asian Alley tại Riga"
              className="rounded-xl md:rounded-2xl shadow-xl md:shadow-2xl w-full h-48 md:h-auto object-cover object-top"
            />
          </div>

          <div>
            <h2 className="text-lg md:text-4xl font-bold text-gray-900 mb-2.5 md:mb-6 font-serif">
              <strong>{t('detail.asian.title')}</strong> {t('detail.asian.titleSub')}
            </h2>
            <p className="text-xs md:text-base text-gray-600 mb-3 md:mb-6 leading-relaxed">
              {t('detail.asian.description')}
            </p>
            <div className="space-y-2 md:space-y-4 mb-3 md:mb-6">
              <div className="flex items-start">
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-gold-600 text-sm md:text-xl"></i>
                </div>
                <div className="ml-1.5 md:ml-3">
                  <strong className="text-xs md:text-base text-gray-900">
                    {t('detail.asian.location.label')}
                  </strong>
                  <p className="text-[10px] md:text-sm text-gray-600">
                    {t('detail.asian.location.value')}
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-line-chart-line text-gold-600 text-sm md:text-xl"></i>
                </div>
                <div className="ml-1.5 md:ml-3">
                  <strong className="text-xs md:text-base text-gray-900">
                    {t('detail.asian.revenue.label')}
                  </strong>
                  <p className="text-[10px] md:text-sm text-gray-600">
                    {t('detail.asian.revenue.value')}
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-team-line text-gold-600 text-sm md:text-xl"></i>
                </div>
                <div className="ml-1.5 md:ml-3">
                  <strong className="text-xs md:text-base text-gray-900">
                    {t('detail.asian.customers.label')}
                  </strong>
                  <p className="text-[10px] md:text-sm text-gray-600">
                    {t('detail.asian.customers.value')}
                  </p>
                </div>
              </div>
            </div>
            <button
              onClick={onConsultClick}
              className="px-5 md:px-8 py-2 md:py-3 bg-gold-600 text-white text-xs md:text-base font-semibold rounded-lg hover:bg-gold-700 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              {t('detail.asian.button')}
            </button>
          </div>
        </div>
      </div>
    </article>
  );
};

export default AsianAlleyInvestSection;